import {
    GETACCOUNTID_SUCCESS,
    GETACCOUNTID_FAILED,
    RESET_GETACCOUNTID,
    LOADING_GETACCOUNTID,
    NETWORK_ERROR_GETACCOUNTID
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetAccountId = () => {
    return { type: RESET_GETACCOUNTID };
};

const getAccountId = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETACCOUNTID });
    await partnerServices
        .post("getAccountIdList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getAccountIdsuccess(res.data));
                    break;
                default:
                    dispatch(getAccountIdFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_GETACCOUNTID,
                payload: err
            });
        });
};
function getAccountIdsuccess(data) {
    return {
        type: GETACCOUNTID_SUCCESS,
        payload: data
    };
}
function getAccountIdFailed(data) {
    return {
        type: GETACCOUNTID_FAILED,
        payload: data
    };
}

export { resetGetAccountId, getAccountId };
